export enum ApiKeysTableSortProps {
  STORE_NAME = "storeName",
}

export interface ApiKeysTableSearchProps {
  storeName: string;
}
